export const menClothings = [
    {   
        id: 0,
        name: 'Crew neck 1',
        price: 19.99,
        image: './asset/crew-neck-male-tshirt.png'

    },
    {
        id: 1,
        name: 'Crew neck 2',
        price: 19.99,
        image: './asset/Crew-neck-male.png'
    },
    {
        id: 2,
        name: 'Hoodie white',
        price: 39.99,
        image: './asset/hoodie-male-01.png'
    },
    {
        id: 3,
        name: 'Hoodie grey',
        price: 39.99,
        image: './asset/hoodie-male-02.png'
    },
    {
        id: 4,
        name: 'Lsleeve tshirt1',
        price: 29.99,
        image: './asset/long-sleeve-male-tshirt-01.png'
    },
    {
        id: 5,
        name: 'Lsleeve shirt2',
        price: 29.99,
        image: './asset/long-sleeve-male-tshirt-02.png'
    },
    {
        id: 6,
        name: 'Lsleeve tshirt3',
        price: 29.99,
        image: './asset/long-sleeve-male-tshirt-03.png'
    },
    {
        id: 7,
        name: 'Lsleeve tshirt4',
        price: 39.99,
        image: './asset/long-sleeve-male-tshirt-04.png'
    },
    {
        id: 8,
        name: 'Lsleeve vneck',
        price: 19.99,
        image: './asset/long-sleeve-v-neck-male-tshirt.png'
    },
    {
        id: 9,
        name: 'Polo white',
        price: 39.99,
        image: './asset/polo-male.png'

    },       
    {
        id: 10,
        name: 'Pullover',
        price: 29.99,
        image: './asset/pullover-male.png'
    },
    {
        id: 11,
        name: 'Tank top 1',
        price: 19.99,
        image: './asset/Tank-top-male-01.png'
    },
    {
        id: 12,
        name: 'Tank top 2',
        price: 19.99,        
        image: './asset/Tank-top-male-02.png'
    },
    {
        id: 13,
        name: 'V-neck tshirt',
        price: 29.99,
        image: './asset/v-neck-male-tshirt.png'
    },
    {
        id: 14,
        name: 'Wide neck tshirt',
        price: 29.99,
        image: './asset/wide-neck-male-tshirt.png'
    }

];
